/** @jsxFrag React.Fragment */
import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import DegreesCategorySchemaMarkup from 'bundles/premium-hub/components/seo/DegreesCategorySchemaMarkup';
import PremiumHubPageHeader from 'bundles/premium-hub/components/shared/PremiumHubPageHeader';
import { HubPages } from 'bundles/premium-hub/constants';
import usePremiumHubPageData from 'bundles/premium-hub/hooks/usePremiumHubPageData';
import OverviewPageContent from 'bundles/premium-hub/pages/subpages/OverviewPageContent';
import type { PremiumProductProps } from 'bundles/premium-hub/types';
import { convertPpcPremiumProductToPremiumProductProps } from 'bundles/premium-hub/utils/dataTransformationUtils';

import _t from 'i18n!nls/premium-hub';

const DegreeProgramLevelHubPageContent = () => {
  const pageType = HubPages.ProductVariantHubPage;
  const premiumHubPageData = usePremiumHubPageData(pageType);

  if (!premiumHubPageData) {
    return null;
  }

  const {
    degreeCategories,
    categoryData,
    premiumProductList,
    useSimplifiedHeader = false,
    pageContent,
  } = premiumHubPageData;

  const degreesForSeo: Array<{ degreeType: string; title: string; degrees: PremiumProductProps[] }> =
    degreeCategories?.map((degreeCategory) => {
      const degreesInCategory = premiumProductList
        ?.filter((degree) => degree.categoryIds.includes(degreeCategory.id))
        .map(convertPpcPremiumProductToPremiumProductProps);
      return {
        degreeType: pageContent?.slug ?? '',
        title: `${degreeCategory.name} ${categoryData?.name ?? _t('Degrees')}`,
        degrees: degreesInCategory ?? [],
      };
    }) ?? [];

  return (
    <>
      <PremiumHubPageHeader isSimplified={useSimplifiedHeader} />
      <main id="main" className="rc-DegreesVariantHubPage" data-testid="degree-program-level-hub-page">
        <DegreesCategorySchemaMarkup allDegreeLists={degreesForSeo} currentHubPage={pageType} />
        <OverviewPageContent {...premiumHubPageData} currentPageType={pageType} shouldShowDriftChat={false} />
      </main>
    </>
  );
};

export default compose<{}, React.PropsWithChildren<{}>>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'program_hub',
      page: 'degree_sub',
    },
  }))
)(DegreeProgramLevelHubPageContent);
